<div class="promo-banner w-100">
  <!-- Desktop: una sola línea -->
  <div class="promo-banner__desktop">
    <span class="promo-banner__text">
      {{ bannerDiscountMessage }}
      <a class="promo-banner__tyc" href="https://www.sura.co/seguros/digitales/terminos-y-condiciones" target="_blank"
        rel="noopener noreferrer">Aplican TyC</a>
      - Finaliza en {{ countdown }}
    </span>
  </div>
  <!-- Mobile: dos líneas -->
  <div class="promo-banner__mobile">
    <span class="promo-banner__text">
      {{ bannerDiscountMessage }}
      <a class="promo-banner__tyc" href="https://www.sura.co/seguros/digitales/terminos-y-condiciones" target="_blank"
        rel="noopener noreferrer">Aplican TyC</a>
    </span>
    <span class="promo-banner__text promo-banner__countdown">
      Finaliza en {{ countdown }}
    </span>
  </div>
</div>